/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * Request to join an umbrella company
 * @export
 * @interface JoinUmbrellaCompanyRequest
 */
export interface JoinUmbrellaCompanyRequest {
    /**
     * ID of the umbrella company to join.
     * @type {string}
     * @memberof JoinUmbrellaCompanyRequest
     */
    umbrellaCompanyId: string;
}

/**
 * Check if a given object implements the JoinUmbrellaCompanyRequest interface.
 */
export function instanceOfJoinUmbrellaCompanyRequest(value: object): value is JoinUmbrellaCompanyRequest {
    if (!('umbrellaCompanyId' in value) || value['umbrellaCompanyId'] === undefined) return false;
    return true;
}

export function JoinUmbrellaCompanyRequestFromJSON(json: any): JoinUmbrellaCompanyRequest {
    return JoinUmbrellaCompanyRequestFromJSONTyped(json, false);
}

export function JoinUmbrellaCompanyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): JoinUmbrellaCompanyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'umbrellaCompanyId': json['umbrellaCompanyId'],
    };
}

export function JoinUmbrellaCompanyRequestToJSON(value?: JoinUmbrellaCompanyRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'umbrellaCompanyId': value['umbrellaCompanyId'],
    };
}

